import React from 'react'

import { CommonDeleteIcon, CommonBlockIcon } from '@local/assets/icons'

import { useModal } from '@web/components/Modal/useModal'
import { UserRelationshipItem_UserFragment } from '@web/gql/graphql'
import useBlockModal from '@web/hooks/useBlockModal'
import useFollowMethods from '@web/hooks/useFollowMethods'
import nClicks from '@web/libs/nlog/click/codes'

import ContextMenu from './ContextMenu/ContextMenu'
import styles from './ContextMenuFollow.module.scss'
import Alert from './Modal/Alert'

interface ContextMenuFollowType {
  showDeleteMenu: boolean
  user: UserRelationshipItem_UserFragment
  onDeleteFollower?: () => void
}

const ContextMenuFollow: React.FC<ContextMenuFollowType> = ({ user, showDeleteMenu, onDeleteFollower }) => {
  const { openBlockModal } = useBlockModal({ user })
  const { deleteFollower } = useFollowMethods()

  const { openModal: openDeleteFollowerModal } = useModal(Alert, {
    label: {
      confirm: '네, 삭제할래요',
      cancel: '아니요',
    },
    title: user?.profile.nickname,
    message: (
      <>
        팔로워 리스트에서 삭제하시겠어요?
        <br />
        삭제하면 상대방의 팔로우는 취소되고,
        <br />
        별도의 알림이 가지 않습니다.
      </>
    ),
    clickCodes: {
      cancel: nClicks.followDeletePopup.DELNO,
      confirm: nClicks.followDeletePopup.DELOK,
    },
    callback: {
      confirm: async () => {
        deleteFollower(user, onDeleteFollower)
      },
    },
  })

  const items = [
    {
      label: '리뷰어 삭제',
      icon: CommonDeleteIcon,
      clickHandler: () => openDeleteFollowerModal(),
      clickCode: nClicks.followListMy.FOLLOWERDELETE,
      visibility: showDeleteMenu,
    },
    {
      label: '리뷰어 차단',
      icon: CommonBlockIcon,
      clickHandler: () => openBlockModal(),
      clickCode: nClicks.followListMy.FOLLOWERBLOCK,
      visibility: true,
    },
  ]

  return (
    <ContextMenu
      button={{
        alt: '팔로워 관리',
        styleClass: styles.btn_manage,
      }}
      layerStyleClass={styles.ly_manage}
      items={items}
    />
  )
}

export default ContextMenuFollow
